const settings = {
    settingsList: [],
    loadingSettings: true
};

export default settings;
